
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { InsightCard, transformDatabaseCard } from '@/types/insight';
import { toast } from 'sonner';

export const useInsightCards = () => {
  const [allCards, setAllCards] = useState<InsightCard[]>([]);
  const [isLoadingCards, setIsLoadingCards] = useState(true);
  
  useEffect(() => {
    fetchAllCards();
  }, []);
  
  const fetchAllCards = async () => {
    try {
      setIsLoadingCards(true);
      
      const { data, error } = await supabase
        .from('insight_cards')
        .select('*, card_insights(id, insight_text)')
        .order('created_at', { ascending: false });
      
      if (error) throw error;
      
      if (data) {
        const transformedCards = data.map(card => transformDatabaseCard(card));
        setAllCards(transformedCards);
      } else {
        // Fallback to static data
        const { insightCardsData } = await import('@/data/insightCardsData');
        setAllCards(insightCardsData);
      }
    } catch (error) {
      console.error('Error fetching cards:', error);
      toast.error('Failed to load insight cards');
      
      // Fallback to static data
      const { insightCardsData } = await import('@/data/insightCardsData');
      setAllCards(insightCardsData);
    } finally {
      setIsLoadingCards(false);
    }
  };
  
  return {
    allCards,
    isLoadingCards,
    refreshCards: fetchAllCards
  };
};
